import { render, staticRenderFns } from "./deviceMagtDetail.vue?vue&type=template&id=2588a2f0"
import script from "./deviceMagtDetail.vue?vue&type=script&lang=js"
export * from "./deviceMagtDetail.vue?vue&type=script&lang=js"
import style0 from "./deviceMagtDetail.vue?vue&type=style&index=0&id=2588a2f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports